module.exports = __webpack_public_path__ + "img/logo_ext.cb14ca43.svg";